// Dial targets that name the number by id, so Talk never needs the contact's full number.
// api-core's dispatcher (ConferencingController::resolveDialById) looks the number up.
export const DIAL_TARGET_CONTACT = 'contact:' // the contact's primary number
export const DIAL_TARGET_CONTACT_PHONE = 'contact_phone:' // one of the contact's phone numbers
export const DIAL_TARGET_CALL_BACK = 'call_back:' // the number of an earlier call or text

export const DIAL_TARGETS_BY_ID = Object.freeze([DIAL_TARGET_CONTACT, DIAL_TARGET_CONTACT_PHONE, DIAL_TARGET_CALL_BACK])
